import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Card,
    CardBody,
    Modal,
    ModalBody,
    Label
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default function EmailForwarding({
    saveIntegration,
    channelDetails
}) {
    const [channelData, setChannelData] = useState({
        emailProvider: "Other",
        forwardingEmail: ""
    })
    useEffect(() => {
        if (channelDetails !== null) {
            setChannelData({
                ...channelData,
                emailProvider: channelDetails.emailProvider,
                forwardingEmail: channelDetails.forwardingEmail
            })
        }
    }, [channelDetails]);
    const handleSave = () => {
        var details = { ...channelDetails };
        details.emailProvider = channelData.emailProvider;
        details.forwardingEmail = channelData.forwardingEmail;
        saveIntegration({ channelDetails: details });
    }
    return (<Fragment>
        <Card className="mb-4">
            <CardBody>
                <div className="text-center mb-2">
                    <h6>Setup Email Forwarding</h6>
                    <span>Enable Unified Inbox to receive, show, and reply to forwarded emails</span>
                </div>
                <Separator className="mb-3" />
                <div className="row mt-1 ml-2 mb-1">
                    <p>Follow these instructions to set up email forwarding</p>
                    <ol className='email-ol'>
                        <li className='mt-4'>Choose your email provider <br />
                            <div className='d-flex'>
                                <CustomInput
                                    type="radio"
                                    id={"google"}
                                    value={"Google"}
                                    label={"Google"}
                                    checked={channelData.emailProvider === "Google" ? true : false}
                                    onChange={(e) => setChannelData({ ...channelData, emailProvider: e.target.value })}
                                />
                                <CustomInput
                                    type="radio"
                                    id={"microsoft"}
                                    value={"Microsoft"}
                                    label={"Microsoft"}
                                    className="ml-4"
                                    checked={channelData.emailProvider === "Microsoft" ? true : false}
                                    onChange={(e) => setChannelData({ ...channelData, emailProvider: e.target.value })}
                                />
                                <CustomInput
                                    type="radio"
                                    id={"other"}
                                    value={"Other"}
                                    label={"Other"}
                                    className="ml-4"
                                    checked={channelData.emailProvider === "Other" ? true : false}
                                    onChange={(e) => setChannelData({ ...channelData, emailProvider: e.target.value })}
                                />
                            </div>
                        </li>
                        <li className="mt-4">Copy your unique forwarding address email below: <br />
                            <div className='row w-100 mt-2'>
                                <Colxx md={8}>
                                    <Input
                                        type="text"
                                        value={channelData.forwardingEmail}
                                        name="text"
                                        onChange={(e) => setChannelData({ ...channelData, forwardingEmail: e.target.value })}
                                    />
                                </Colxx>
                                <Colxx md={4}>
                                    <CopyToClipboard
                                        text={channelData.forwardingEmail}
                                    >
                                        <Button
                                            size="xs"
                                            outline
                                            className="ml-3 mt-1">
                                            <FontAwesomeIcon icon={faCopy} className="fa" /> Copy
                                        </Button>
                                    </CopyToClipboard>
                                </Colxx>
                            </div>
                        </li>
                        <li className="mt-4">Sign into your email provider and find the settings for email forwarding. Then, save the address above as your forwarding address.</li>
                        <li className="mt-4">For domain providers requesting a confirmation code.<br />
                            <p>The email with confirmation code will appear in your Unified Inbox when the verification process is initiated.</p>
                        </li>
                        <li className="mt-4"> Check that Myma.ai’s Unified Inbox is receiving your incoming email by sending a test message. It should appear in your Unified Inbox</li>
                    </ol>
                </div>
                <div className="text-center">
                    <Button
                        size="xs"
                        color="primary"
                        outline
                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>
    </Fragment>)
}  